import { addDays, startOfWeek } from 'date-fns';
import type { PostingLogRow } from '@/utils/PostingLog/types';

type WeekStartDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/**
 * The week-ending date of a timesheet's posting lines: the timesheet's own WeekEnding when
 * available, otherwise the canonical week end (week start + 6, matching
 * TimesheetService.NormalizeWeekEnding) of the latest transaction date.
 */
export const resolvePostingLogWeekEnding = (
  lines: PostingLogRow[],
  weekStartDay: WeekStartDay,
): Date | null => {
  const stored = lines.find((l) => l.weekEnding)?.weekEnding;
  if (stored) return stored;

  const dates = lines.flatMap((l) => (l.transactionDate ? [l.transactionDate.getTime()] : []));
  if (dates.length === 0) return null;

  return addDays(startOfWeek(new Date(Math.max(...dates)), { weekStartsOn: weekStartDay }), 6);
};
